import { faker } from '@faker-js/faker';
import { userId, tenantId } from '@cnx-saas/utils-cnx-id';
import { User, UserLanguages, UserType } from '../types';

export const fakeUserFactory = {
  createUser: (user: Partial<User> = {}): User => ({
    userId: userId(),
    tenantId: tenantId(),
    userType: UserType.USER,
    email: faker.internet.email(),
    ...user,
  }),
};

export const fakeUser: User = fakeUserFactory.createUser();

export const getRandomUserLanguage = () =>
  UserLanguages[
    faker.helpers.arrayElement(
      Object.keys(UserLanguages),
    ) as keyof typeof UserLanguages
  ];
